export const home = {
  nav: {
    ariaPrimary: "Navegación principal",
    cta: "Hablar con la mesa",
    ghost: "Iniciar sesión",
    links: {
      product: "Producto",
      api: "API",
      security: "Seguridad",
      pricing: "Precios",
      faq: "FAQ",
      contact: "Contacto",
    },
  },
  hero: {
    tag: "Multi-red · Liquidación 24/7",
    titleLine1: "Cobra en cualquier moneda.",
    titleLine2Prefix: "Recibe",
    titleLine2Highlight: "en la tuya.",
    description:
      "Fiat, stablecoin y cripto en un único flujo. Liquidez propia para entrega inmediata. Operación institucional integrada.",
    cta: "Hablar con la mesa",
    ctaSecondary: "Ver la API",
    imageAlt: "Operación multiactivo y liquidación cross-currency",
    trustLabel: "Construido para operar con",
    flow: {
      label: "Ejemplo de flujo",
      status: "Liquidado en segundos",
    },
  },
  trustMarquee: {
    eyebrow: "Cobertura",
    title: "Monedas y rieles soportados",
    description:
      "Un conjunto curado de activos fiat, stablecoins y cripto — en todas las redes principales.",
    assetLabels: {
      USD: "Dólar estadounidense",
      BRL: "Real brasileño",
      EUR: "Euro",
      MXN: "Peso mexicano",
      USDT: "Tether",
      USDC: "USD Coin",
      DAI: "Dai",
      BTC: "Bitcoin",
      ETH: "Ethereum",
    },
  },
  howItWorks: {
    eyebrow: "Flujo",
    title: "Tres pasos. Un único riel.",
    description:
      "Sigue un pago real: cobro en USD, cliente paga en cripto, recibes en BRL — todo en el mismo riel.",
    steps: {
      "01": {
        kicker: "Emisión",
        title: "Cobras en cualquier moneda",
        subtitle: "En menos de un minuto creas la factura y envías el enlace.",
        description:
          "Define en qué moneda quieres cobrar y en cuál quieres recibir. La mesa le muestra al cliente todas las formas de pago disponibles.",
        meta: "Panel · API · SDK",
        effect: "Factura creada y lista para recibir.",
        artifactLabel: "POST /v1/invoices",
        artifactKeys: {
          charge: "charge",
          receive: "receive",
          payment_options: "payment_options",
        },
      },
      "02": {
        kicker: "Pago",
        title: "Tu cliente paga como prefiera",
        subtitle: "Fiat, stablecoin o cripto — en cualquier red soportada.",
        description:
          "La validación de red, tipo de cambio y compliance son cosa nuestra. Tu cliente solo elige el medio más conveniente.",
        meta: "Multiactivo · Multi-red",
        effect: "Pago confirmado. Red y tipo de cambio validados.",
        fromNote: "Cliente envió",
        toNote: "Detectado y validado",
        toRail: "equivalente",
      },
      "03": {
        kicker: "Liquidación",
        title: "Recibes en tu moneda, al instante",
        subtitle: "Liquidez propia cierra el ciclo en segundos.",
        description:
          "Sin ventana bancaria ni confirmación de terceros. Un webhook firmado dispara tu conciliación automática.",
        meta: "Liquidación instantánea",
        effect: "Valor acreditado. Conciliación automática disparada.",
      },
    },
  },
  differentials: {
    kicker: "Por qué la mesa",
    title: "Lo que hace que la mesa sea la mesa.",
    description:
      "Cuatro capas de infraestructura construidas para quien cobra y liquida a escala — no para quien experimenta.",
    hero: {
      title: "Liquidez propia",
      subtitle: "El dinero llega ahora, no mañana.",
      description:
        "Entrega inmediata sin depender de ventana bancaria, confirmación de terceros o liquidez externa. Fondos propios cierran el ciclo en segundos.",
      metric: {
        value: "~18s",
        label: "tiempo medio de liquidación",
      },
    },
    items: {
      multiativo: {
        title: "Multiactivo nativo",
        description:
          "Fiat, stablecoin y cripto en un único flujo. No es crypto-only ni fiat-only — es un único riel.",
        proof: "3 clases · 1 riel",
      },
      multiRede: {
        title: "Multi-red con validación",
        description:
          "Validación cross-red automática. Nunca envía a dirección o red incorrecta.",
        proof: "Cero errores de red",
      },
      institucional: {
        title: "Operación institucional",
        description:
          "Compliance, ledger auditable y segregación de ambientes integrados. Tus controles, nuestro trabajo.",
        proof: "KYC · AML · BACEN",
      },
    },
  },
  useCases: {
    kicker: "Para quién es la mesa",
    title: "¿Reconoces tu operación aquí?",
    description:
      "Cuatro perfiles, un riel. La mesa se adapta a tu dolor — no al revés.",
    cta: "Hablar con la mesa",
    cases: {
      exportadora: {
        label: "Exportadora",
        painCta: "Cobra en USD, recibe en BRL",
        headline: "Vende en el exterior, recauda en Brasil.",
        description:
          "Emite facturas en USD o EUR y recibe en BRL con tipo de cambio y liquidación en el mismo flujo — sin intermediarios.",
        bullets: [
          "Conversión automática a la moneda contratada",
          "Comprobante fiscal compatible con exportación",
          "Liquidación en horas, no en días",
        ],
      },
      fintech: {
        label: "Fintech",
        painCta: "Acepta cripto, liquida en fiat",
        headline: "Cobro cripto sin convertirte en exchange.",
        description:
          "Acepta USDT, USDC o BTC de tu cliente y liquida automáticamente en BRL o USD — sin custodia, sin KYC adicional.",
        bullets: [
          "Webhooks HMAC para conciliación en tiempo real",
          "Validación cross-red evita pérdida de fondos",
          "Compliance heredado, sin carga extra",
        ],
      },
      plataforma: {
        label: "Plataforma",
        painCta: "Checkout multiactivo en LATAM",
        headline: "Cualquier moneda en el checkout.",
        description:
          "Plataformas internacionales que venden en América Latina usan la mesa para aceptar fiat local, stablecoin y cripto en un único riel.",
        bullets: [
          "Integración API o panel en menos de un día",
          "Tasas transparentes por tramo de volumen",
          "SDK Node, Python y Go con ejemplos reales",
        ],
      },
      global: {
        label: "Empresa Global",
        painCta: "Tesorería en 3+ monedas",
        headline: "Cobro y tesorería multi-moneda.",
        description:
          "Empresas en múltiples países consolidan cobro, cambio y tesorería en un único riel auditable.",
        bullets: [
          "Conciliación automática por referencia única",
          "Informes por moneda, entidad y contrato",
          "Ledger auditable, compatible con Big 4",
        ],
      },
    },
  },
  assetsRails: {
    kicker: "Cobertura completa",
    title: "Un riel. Muchas monedas.",
    description:
      "Empezamos con un conjunto curado — fiat, stablecoin y cripto — que cubre la mayoría de los corredores de pago. Más próximamente, siempre con validación real.",
    linkLabel: "Ver catálogo completo",
    moreInBreve: "+ próximamente",
    stats: {
      moedas: "monedas activas",
      redes: "redes y rieles",
      classes: "clases de activo",
    },
    columns: {
      fiat: { label: "Fiat", caption: "Liquidación bancaria directa" },
      stablecoins: { label: "Stablecoins", caption: "Multi-red con validación" },
      crypto: { label: "Criptoactivos", caption: "Rieles nativos" },
    },
    currencyLabels: {
      USD: "Dólar estadounidense",
      BRL: "Real brasileño",
      EUR: "Euro",
      MXN: "Peso mexicano",
      USDT: "Tether",
      USDC: "USD Coin",
      DAI: "Dai",
      BTC: "Bitcoin",
      ETH: "Ethereum",
    },
  },
  security: {
    kicker: "Seguridad & Compliance",
    title: "Controles institucionales, desde el primer día.",
    description:
      "Cada transacción pasa por una capa de compliance real. No es marketing — es código, log y política.",
    note:
      "Sin certificaciones inventadas. Solo los controles implementados hoy, auditables por quien contrata.",
    pillars: {
      kyc: {
        category: "Onboarding",
        title: "KYC / KYB completo",
        description:
          "Validación documental de personas y empresas antes del primer trade. Revisión de sanciones y PEP.",
      },
      aml: {
        category: "Transaccional",
        title: "Monitoreo AML",
        description:
          "Reglas y tipologías aplicadas en tiempo real. Flags revisadas por analistas humanos.",
      },
      custody: {
        category: "Custodia",
        title: "Custodia segregada",
        description:
          "Fondos de clientes separados del balance operativo. Sin caja única, sin riesgo cruzado.",
      },
      ledger: {
        category: "Auditoría",
        title: "Ledger auditable",
        description:
          "Cada movimiento registrado con hash encadenado. Exportable en CSV o vía API para tu equipo contable.",
      },
      regulatory: {
        category: "Regulatorio",
        title: "Conformidad regulatoria",
        description:
          "Operación alineada con BACEN y COAF en Brasil. Políticas documentadas y revisadas trimestralmente.",
      },
      environments: {
        category: "Infraestructura",
        title: "Segregación de ambientes",
        description:
          "Producción, staging y sandbox aislados por red y credencial. Claves efímeras en cada deploy.",
      },
    },
  },
  api: {
    kicker: "/ 04 · Para desarrolladores",
    rail: "API",
    statusLabel: "API operational",
    title: "Todo lo que la mesa hace, lo haces por la API.",
    description:
      "REST versionado, Webhooks firmados con HMAC-SHA256, sandbox idéntico a producción. Primera llamada en minutos, no en días.",
    tabs: { request: "Request", response: "Response" },
    copyLabel: "Copiar",
    copiedLabel: "Copiado",
    signature: "BUILT FOR DEVELOPERS",
    specSheetLabel: "Especificación técnica",
    stats: {
      uptime: "Uptime SLA",
      latency: "P50 latency",
      regions: "Regiones",
      sdks: "SDKs oficiales",
    },
    spec: {
      protocol: { label: "Protocol", value: "REST · HTTP/1.1, HTTP/2", note: "JSON + UTF-8" },
      auth: { label: "Auth", value: "Bearer token + HMAC-SHA256", note: "Rotación in-place" },
      limits: { label: "Rate limit", value: "1.000 req/min · burst 50", note: "Header ratelimit" },
      versioning: { label: "Versioning", value: "Semver · deprecation 12 meses", note: "Changelog público" },
      sdks: { label: "SDKs", value: "Node · Python · Go · Ruby", note: "Ejemplos reales" },
      sandbox: { label: "Sandbox", value: "Espejo completo de producción", note: "Datos ficticios" },
    },
    ctaPrimary: "Leer la documentación",
    ctaSecondary: "Solicitar acceso a la API",
  },
  pricing: {
    kicker: "/ 09 · Precios",
    rail: "PRICING",
    tag: "Por cotización",
    title: "Precio por cotización. Sin sorpresas, sin cobros ocultos.",
    description:
      "Trabajamos con modelos por tramo de volumen, spread transparente y tasa de liquidación acordada por contrato. Sin tarifa de setup.",
    formulaLabel: "Modelo de precio",
    legend: {
      spread: "Diferencia visible entre bid y ask",
      volume: "Tramo mensual acordado por contrato",
      ativo: "Fiat · stablecoin · cripto",
    },
    attributes: {
      setupFee: { label: "Setup fee", value: "Cero", note: "Sin cargo de entrada" },
      spread: { label: "Spread", value: "Transparente", note: "Mostrado en cada cotización" },
      taxa: { label: "Tasa", value: "Por tramo de volumen", note: "Negociada por contrato" },
      contrato: { label: "Contrato", value: "Personalizable", note: "Términos a medida" },
    },
    process: {
      label: "Proceso",
      "01": { label: "Conversación inicial", detail: "15 minutos sobre el caso" },
      "02": { label: "Estimación", detail: "Hasta 1 día hábil" },
      "03": { label: "Contrato", detail: "Términos por escrito" },
    },
    primaryCta: "Hablar con la mesa",
    ctaHelper: "Nadie vende. Solo evalúa tu caso.",
    note: "Estimación inicial en hasta 1 día hábil tras una breve conversación sobre tu caso.",
    signature: "TRANSPARENT BY DESIGN",
  },
  faq: {
    kicker: "Preguntas frecuentes",
    title: "Preguntas que llegan antes del primer call.",
    description: "Si queda alguna pregunta después de esto, habla con la mesa.",
    items: {
      what: {
        question: "¿Qué es MesaOTC?",
        answer:
          "Infraestructura de cobro y liquidación multiactivo. Cobras en una moneda y recibes en otra — fiat, stablecoin o cripto — con liquidez propia y operación institucional integrada. No es exchange, broker ni wallet.",
      },
      liquidation: {
        question: "¿Cómo funciona la liquidación?",
        answer:
          "Tu cliente paga en la moneda elegida y la mesa entrega en la moneda que definiste como receiving. Usamos liquidez propia para cerrar el ciclo — sin depender de brókers externos ni ventanas de mercado. En general, en minutos tras la confirmación on-chain o bancaria.",
      },
      assets: {
        question: "¿Qué monedas y redes soportan?",
        answer:
          "Fiat: BRL (PIX, TED), USD (WIRE, ACH), EUR (SEPA), MXN (SPEI). Stablecoins: USDT (ERC20, TRC20, Polygon), USDC (ERC20, Solana, Base), DAI (ERC20). Cripto: BTC (Mainnet, Lightning), ETH (Mainnet). Activos adicionales se habilitan según demanda y validación.",
      },
      compliance: {
        question: "¿Cómo se hace el compliance?",
        answer:
          "KYC y KYB completo antes del primer trade (documentación, sanciones, PEP). Monitoreo AML en tiempo real con reglas y tipologías. Custodia segregada, ledger auditable con hash encadenado, segregación de ambientes (producción/staging/sandbox). Operación alineada con BACEN y COAF.",
      },
      integration: {
        question: "¿Cuánto tiempo lleva integrar?",
        answer:
          "La mayoría de los equipos hace la primera llamada en sandbox en menos de un día. Producción depende del KYB y del tipo de integración — panel solo requiere registro; API requiere credencial de producción tras validación.",
      },
      costs: {
        question: "¿Cuáles son los costos?",
        answer:
          "Precio acordado por contrato, con base en tramo de volumen, monedas operadas y redes usadas. Sin setup fee. Estimación inicial hasta 1 día hábil tras una breve conversación sobre tu caso.",
      },
      sla: {
        question: "¿Tienen SLA?",
        answer:
          "Sí. SLA de disponibilidad de la API, tiempo medio de liquidación y canal dedicado de soporte se definen por contrato, según el tier de volumen. Estado público en status.mesaotc.com.",
      },
      "api-access": {
        question: "¿Cómo solicito acceso a la API?",
        answer:
          "Solicita acceso en contato@mesaotc.com o por el CTA 'Solicitar acceso a la API'. Tras validación básica, enviamos credenciales de sandbox inmediatamente; credenciales de producción salen tras KYB completado.",
      },
    },
  },
  contact: {
    kicker: "/ 11 · Contacto",
    rail: "CONTACT",
    title: "Cuenta el caso. Respondemos en 1 día hábil.",
    description:
      "Una conversación de 15 minutos basta para evaluar si tiene sentido para tu operación. Sin vendedor, sin pitch.",
    reassuranceSpec: {
      response: { label: "Respuesta", value: "En 1 día hábil" },
      assessment: { label: "Evaluación", value: "Gratuita, sin compromiso" },
      privacy: { label: "Sigilo", value: "NDA implícito desde la primera línea" },
    },
    reassurance: [
      "Respuesta en hasta 1 día hábil",
      "Evaluación gratuita",
      "Sigilo de información",
    ],
    successTitle: "Recibido.",
    successMessage:
      "Recibimos tu mensaje. Un consultor responde en 1 día hábil a tu email.",
    successHint: "Mientras tanto, puedes",
    successLinkLabel: "leer la documentación",
    submitCta: "Enviar mensaje",
    submitMicrocopy:
      "Puedes responder esta conversación directamente desde tu bandeja.",
    signature: "STARTS A CONVERSATION",
    altChannels: {
      label: "Canales directos",
      directLabel: "Direct",
      agendaLabel: "Agendar",
      agendaValue: "cal.com/mesaotc",
    },
    form: {
      sectionLabel: "Formulario",
      nameLabel: "Nombre",
      namePlaceholder: "Tu nombre completo",
      nameHint: "Cómo quieres ser llamado",
      companyLabel: "Empresa",
      companyPlaceholder: "Nombre de la empresa",
      companyHint: "Razón social o nombre comercial",
      emailLabel: "Email corporativo",
      emailPlaceholder: "tu@empresa.com",
      emailHint: "Usa un email corporativo",
      volumeLabel: "Volumen estimado / mes",
      volumePlaceholder: "Selecciona un tramo",
      volumeHint: "Tramo mensual aproximado",
      volumeOptions: {
        "ate-30k": "Hasta USD 30 mil",
        "30k-100k": "USD 30 mil – 100 mil",
        "100k-500k": "USD 100 mil – 500 mil",
        "500k-1m": "USD 500 mil – 1 millón",
        "1m-5m": "USD 1 millón – 5 millones",
        "5m+": "Superior a USD 5 millones",
        avaliando: "Aún evaluando",
      },
      messageLabel: "Mensaje",
      messagePlaceholder:
        "Cuenta brevemente sobre tu operación — monedas involucradas, frecuencia, objetivo.",
      messageHint: "Hasta 1000 caracteres",
      validation: {
        nameRequired: "Ingresa tu nombre.",
        companyRequired: "Ingresa el nombre de la empresa.",
        emailRequired: "Ingresa tu email corporativo.",
        emailInvalid: "Email inválido.",
        emailPersonal: "Usa un email corporativo.",
        volumeRequired: "Selecciona un tramo de volumen.",
        messageRequired: "Cuenta brevemente sobre tu operación.",
      },
    },
  },
  finalCta: {
    title: "¿Listo para operar en cualquier moneda?",
    description:
      "Conecta la mesa a tu flujo de cobro y liquidación en una conversación.",
    primaryCta: "Hablar con la mesa",
    secondaryCta: "Leer la documentación",
  },
  footer: {
    tagline: "Infraestructura de cobro y liquidación multiactivo.",
    columns: {
      product: {
        label: "Producto",
        links: {
          howItWorks: "Cómo funciona",
          useCases: "Casos de uso",
          assets: "Activos & rieles",
          security: "Seguridad",
          pricing: "Precios",
        },
      },
      developer: {
        label: "Desarrollador",
        links: {
          docs: "Documentación",
          apiReference: "Referencia de API",
          status: "Status",
          changelog: "Changelog",
        },
      },
      company: {
        label: "Empresa",
        links: {
          useCases: "Casos de uso",
          contact: "Contacto",
          faq: "FAQ",
        },
      },
      legal: {
        label: "Legal",
        links: {
          privacy: "Privacidad",
          terms: "Términos",
          compliance: "Compliance",
        },
      },
    },
    meta: {
      address: "São Paulo, Brasil",
      legalName: "MesaOTC Tecnologia Ltda.",
      statusLabel: "Operación estable",
      region: "BRASIL · LATAM",
      rights: "Todos los derechos reservados.",
    },
    languageLabel: "Idioma",
  },
  theme: {
    toLight: "Activar tema claro",
    toDark: "Activar tema oscuro",
  },
} as const
